export default __webpack_public_path__ + "static/media/레진_mobile.f6f7497f.jpg";